var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('RomaPdfViewer',{attrs:{"pdfDoc":_vm.selectedPdf}}),_c('RomaHorizontalPoll')],1)}
var staticRenderFns = []

export { render, staticRenderFns }